
export const duration = {
    seconds: function (val) { return val; },
    minutes: function (val) { return val * this.seconds(60); },
    hours: function (val) { return val * this.minutes(60); },
    days: function (val) { return val * this.hours(24); },
    weeks: function (val) { return val * this.days(7); },
    years: function (val) { return val * this.days(365); },
};


export const getChainCurrency = (blockChainNetworkId) => 
    (blockChainNetworkId === "1" || blockChainNetworkId === "3" || blockChainNetworkId === "42") ? 'ETH' :
    (blockChainNetworkId === "56" || blockChainNetworkId === "97") ? 'BNB' : '-';

export const getNetworkName = (blockChainNetworkId) => 
    blockChainNetworkId === "1" ? 'Ethereum' :
    blockChainNetworkId === "3" ? 'Ropsten' :
    blockChainNetworkId === "42" ? 'Kovan' :
    blockChainNetworkId === "56" ? 'Binance' :
    blockChainNetworkId === "97" ? 'Binance Test' : '-';


export const getChainSymbol = (blockChainNetworkId) => 
    (blockChainNetworkId === "1" || blockChainNetworkId === "3" || blockChainNetworkId === "42") ? 'ETH' :
    (blockChainNetworkId === "56" || blockChainNetworkId === "97") ? 'BSC' : '-';   
